<template>
  <form data-vv-scope="data-group">
    <div class="row mb-5">
      <div class="col-md-6 mt-3">
        <vs-input
          class="w-100"
          label="Código"
          maxlength="40"
          v-model="editGroup.codigo"
          name="groupCode"
          :danger="errors.has('data-group.groupCode')"
          :danger-text="errors.first('data-group.groupCode')"
          v-validate="'required'"
        />
      </div>
      <div class="col-md-6 mt-3">
        <vs-input
          class="w-100"
          label="Nombre de la oficina"
          maxlength="250"
          name="groupName"
          v-model="editGroup.nombre"
          :danger="errors.has('data-group.groupName')"
          :danger-text="errors.first('data-group.groupName')"
          v-validate="'required'"
        />
      </div>
      <div class="col-md-12 mt-3">
        <vs-input
          class="w-100"
          label="Descripción de la oficina"
          maxlength="250"
          name="groupDescription"
          v-model="editGroup.descripcion"
          :danger="errors.has('data-group.groupDescription')"
          :danger-text="errors.first('data-group.groupDescription')"
          v-validate="'required'"
        />
      </div>
      <div class="col-md-6 mt-3">
        <vs-select
          class="w-100"
          autocomplete
          :label="isMop ? 'Regiones' : 'Categorias'"
          description-text="Si no hay debe crearlas en mantenedor"
          id="region"
          name="region"
          ref="region"
          v-model="editGroup.regionId"
          :danger="errors.has('data-group.region')"
          :danger-text="errors.first('data-group.region')"
          :placeholder="isMop ? 'Seleccione una región' : 'Seleccione una categoría'"
          v-validate="'required'"
        >
          <vs-select-item
            v-for="(region, index) in categoryRegions"
            :key="index"
            :value="region.opcionId"
            :text="region.descripcion"
          />
        </vs-select>
      </div>
      <div class="col-md-6 mt-3">
        <vs-select
          class="w-100"
          autocomplete
          :label="isMop ? 'Servicios' : 'Subcategorias'"
          description-text="Si no hay debe crearlos en mantenedor"
          id="servicio"
          name="servicio"
          ref="servicio"
          v-model="editGroup.servicioId"
          :danger="errors.has('data-group.servicio')"
          :danger-text="errors.first('data-group.servicio')"
          :placeholder="isMop ? 'Seleccione un servicio' : 'Seleccione una subcategoría'"
          v-validate="'required'"
        >
          <vs-select-item
            v-for="(service, index) in categoryServices"
            :key="index"
            :value="service.opcionId"
            :text="service.descripcion"
          />
        </vs-select>
      </div>
      <div class="col-md-12 mt-5">
        <div class="row">
          <div class="col-md-4">
            <label>Esta oficina va a tener numeración</label>
          </div>
          <div class="col-md-4">
            <vs-radio
              data-cy="internalOffice"
              vs-name="isPrivate"
              :vs-value="'int'"
              v-model="editGroup.tipo"
            >
              Interna
            </vs-radio>
          </div>
          <div class="col-md-4">
            <vs-radio
              data-cy="externalOffice"
              vs-name="isPrivate"
              :vs-value="'ext'"
              v-model="editGroup.tipo"
            >
              Oficina de partes
            </vs-radio>
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-3">
        <div style="float: right">
          <vs-button
            data-cy="save"
            class="action"
            color="primary"
            type="border"
            @click="saveChanges()"
            icon="save"
          >
            Guardar
          </vs-button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    group: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: '',
      required: true
    },
    fillTree: {
      type: Function,
    }
  },
  data() {
    return {
      editGroup: {
        ...this.group,
        tipo: this.group.tipo || 'int',
        regionId: null,
        servicioId: null,
        isMop: null,
      }
    };
  },
  created() {
    this.isMop = this.company.iut === '61202000-0';
    this.listCategories({
      grupoOpcion: 'tipos.regiones-ed',
      deshabilitado: 'si'
    });
    this.listCategories({
      grupoOpcion: 'tipos.servicios-ed',
      deshabilitado: 'si'
    });
    this.editGroup.regionId = this.group.regionId;
    this.editGroup.servicioId = this.group.servicioId;
  },
  watch: {
    group(newValue) {
      this.editGroup = { ...newValue };
    }
  },
  computed: {
    ...mapGetters('Herramientas', [
      'categoryRegions',
      'categoryServices'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    showModal: {
      get() {
        return this.modalName === 'modalEditGroup';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Herramientas', [
      'listCategories',
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Empresas', [
      'updateGroup',
      'createGroup'
    ]),
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async saveChanges() {
      const isValid = await this.validateForm('data-group');
      if (!isValid) {
        return;
      }
      const group = {
        ...this.editGroup
      };

      group.esOficina = 'Y';
      group.esDivision = 'N';
      group.regionNombre = this.categoryRegions.find(
        (r) => r.opcionId === this.editGroup.regionId
      ).descripcion;
      group.servicioNombre = this.categoryServices.find(
        (r) => r.opcionId === this.editGroup.servicioId
      ).descripcion;

      if (this.action === 'add' || this.action === 'addParent') {
        await this.createGroup({
          empresaId: this.company.id,
          group
        });
      } else {
        await this.updateGroup({
          empresaId: this.company.id,
          group
        });
      }
      this.$emit('close-action');
    }
  }
};
</script>
<style scoped>
.chip-custom {
  font-size: 12px;
  margin-top: 10px;
  color: #ffb300;
  background: #fff5df;
  border-radius: 10px;
  padding: 4px 8px;
}
</style>
